import React, { PropsWithChildren, createContext, useContext, useState } from 'react'

interface ApplicationContextType {
  menuOpen: boolean
  setMenuOpen: (menuOpen: boolean) => void
}

const ApplicationContext = createContext({} as ApplicationContextType)

const ApplicationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(true)

  return (
    <ApplicationContext.Provider
      value={{
        menuOpen,
        setMenuOpen,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  )
}

const useApplication = () => useContext(ApplicationContext)

export { ApplicationProvider, useApplication }
